import React from 'react';
import classNames from 'classnames';

import styles from './index.module.scss';

const SkipLinks = () => (
  <a href='#main' className={classNames(styles.skip_link, 'skip-link')} title='Skip to content'>
    Skip to content
  </a>
);

export default SkipLinks;
